import axios from "axios";

import { getAuthHeader } from "../headers";

// ===================================================================================
//  GET ALL REVIEWERS REGISTERED FOR SOMETHING
// ===================================================================================
export const getRegistrationIsProcess = () => {
	return {
		type: "GET_REGISTRATION_IN_PROCESS"
	}
}
export const getRegistrationHasError = err => {
	return {
		type: "GET_REGISTRATION_HAS_ERROR",
		error: err
	}
}
export const getRegistrationSuccess = data => {
	return {
		type: "GET_REGISTRATION_SUCCESS",
		data: data
	}
}

export function getRegisteredReviewers(){
	return(dispatch, getState) => {
		dispatch(getRegistrationIsProcess());

		return axios
			.get(process.env.REACT_APP_API_URL + "registered/", {
				headers: getAuthHeader(getState().user)
			})
			.then(response => {
				if (response.data.status && response.data.status !== 200) {
					if (response.data.message !== "") {
						dispatch(getRegistrationHasError(response.data.message));
					} else {
						dispatch(getRegistrationHasError(response.data.errors));
					}
				} else {
					dispatch(getRegistrationSuccess(response))
                }
            })
			.catch(err => {
				dispatch(getRegistrationHasError(err.response.data.message));
			});
	}
}


// WEBPACK FOOTER //
// ./src/store/actions/registered.js